export const GET_IS_CONNECTED = 'GET_IS_CONNECTED'
export const GET_RECONNECT_ERROR = 'GET_RECONNECT_ERROR'
